import request from '../utils/request'

export function customerOverdueListPageApi (data) {
  return request({
    url: 'api/customer/overdueListPage',
    method: 'post',
    data
  })
}
